<template>
<div class="rec_reason_container">
  <!-- 推荐理由 -->
  <!-- 好评榜 2 rated -->
  <div class="reason_rate_2" v-if="selectedType === '2'">
    <div class="left_score">
      <RichText :text="recReason[0].content" />
    </div>
    <div class="right_icon">
      <RichText class="review_num" :text="recReason[1].content" />
      <div class="icon">
        <div v-for="(r, index) in recReason" :key="index" class="item">
          <img v-if="index !== 0 && index !== 1" :src="r.rightImg"/>
        </div>
      </div>
    </div>
  </div>
  <!-- 热卖榜 1 seller -->
  <div class="reason_seller_1" v-if="selectedType === '1'">
    <div class="seller_item" v-for="(r, index) in recReason" :key="index">
      <div v-if="r.content">
        <RichText class="review_num" :text="r.content" />
      </div>
      <div v-if="r.rightImg">
        <img :src="r.rightImg" />
      </div>
    </div>
  </div>
  <!-- 复购榜 3 repurchase -->
  <div class="reason_repurchase_3" v-if="selectedType === '3'">
    <div class="seller_item" v-for="(r, index) in recReason" :key="index">
      <img v-if="r.leftImg" :src="r.leftImg" />
      <div v-if="r.content" class="repurchase_content">
        <RichText class="rec_reason" :text="r.content" />
      </div>
    </div>
  </div>
</div>
</template>
<script>
import RichText from '@/components/RichText';
export default {
  props: {
    recReason: {
      type: Array,
      defalut: [],
    },
    selectedType: {
      type: String,
      default: ''
    }
  },
  components: {
    RichText
  },
  mounted() {
    console.log('recReason:', this.selectedType)
  },
  computed: {
    
  },
  methods: {

  }
}
</script>
<style lang="scss" scoped>
.rec_reason_container {
  position: absolute;
  bottom:0;
  left:0;
  display: flex;
  align-items: center;
  background: rgba(0,0,0,0.80);
  border-radius: 28px;
  .reason_rate_2 {
    padding: 0 20px 0 20px;
    width: fit-content;
    height: 78px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    .left_score {
      margin-top: -2px;
      font-family: DiDiSans-Pro-Bold;
      font-size: 56px;
      color: #FF8040;
      letter-spacing: 0;
      font-weight: 700;
    }
    .right_icon {
      margin-left: 4px;
      margin-top: 3px;
      display: flex;
      flex-direction: column;
      .review_num {
        white-space: nowrap;
        opacity: 0.8;
        font-family: DiDiSans-Pro-Regular;
        font-size: 18px;
        color: #FFFFFF;
        font-weight: 400;
      }
      .icon {
        display: flex;
        .item {
          height: 18px;
          display: flex;
          img {
            width: 18px;
            height: 18px;
          }
        }
      }
    }
  }
  .reason_seller_1, .reason_repurchase_3 {
    display: flex;
    padding: 10px 16px 10px 16px;
    .seller_item {
      display: flex;
      opacity: 0.8;
      font-family: DiDiSans-Pro-Regular;
      font-size: 24px;
      color: #FFFFFF;
      letter-spacing: 0;
      line-height: 24px;
      font-weight: 400;
      white-space: nowrap;
      img {
        width: 24px;
        height: 24px;
      }
    }
  }
}
</style>